import { EkranBledu } from '@insolitum/ui';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Brak uprawnień (403). Wspólny ekran awarii, ale BEZ rozsypanego znaku —
 * system działa, to człowiek nie ma uprawnień, więc znak stoi w spoczynku
 * (`EkranBledu` rozstrzyga to sam dla wariantu `brak-dostepu`). Zdania są
 * domyślne z `TRESCI_EKRANU_BLEDU`: mówią, kto nadaje dostęp i co zrobić.
 */
export function UnauthorizedPage() {
  return (
    <EkranBledu
      wariant="brak-dostepu"
      uklad="pelny"
      akcje={
        <Link to="/admin" className="btn btn--primary btn--lg">
          <ArrowLeft className="w-5 h-5" />
          Wróć do panelu
        </Link>
      }
    />
  );
}
